import FilterListIcon from "@mui/icons-material/FilterList";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import * as React from "react";
import { useSelector } from "react-redux";
import {
  CAMPAIGN_PROPS,
  CAMPAIGN_TYPES,
  HISTORY_PROPS,
  PARKERS_PROPS,
  PARKING_STATUSES,
  SCOPE_TYPE,
  SUBSCRIPTION_STATUSES,
  TABLES,
  VALIDATION_TYPE,
} from "../../../../enums/Enums";
import Colors from "../../../../resources/Colors";
import Icons from "../../../../resources/icons/Icons";
import Strings from "../../../../resources/Strings";
import { capitalCaseToTitleCaseString, getSiteIconName } from "../../../../utils/CommonUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "./QuickFilterToolBar.module.css";
import customInputClasses from "../../Inputs/CustomInputs.module.css";
import { Box } from "@mui/system";
import CustomDatePicker from "../../Inputs/CustomInputs/CustomDatePicker";
import SelectInput from "../../Inputs/CustomInputs/SelectInput";
import { ListItem } from "../../../../entities/UIEntities/ListItem";
import { CAMPAIGN_TYPE_LIST } from "../../../../constants/Constants";

const QuickFilterToolBar = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const currentSites = useSelector((state) => state.user.selectedSites);
  const currentUserTypes = useSelector((state) => state.user.currentUserTypes);
  const chargeAccounts = useSelector((state) => state.billing.validationHistoriesData).validationHistories.map(vh => vh.chargeAccount);
  const currentChargeAccounts = chargeAccounts?.filter((item, index) => chargeAccounts?.findIndex((ch) => ch.id === item.id) === index);
  const chargeAccountList = currentChargeAccounts?.map(ch => new ListItem(ch.id, ch.name, ch.name));
  const selectedSiteIds = props.value[PARKERS_PROPS.SITES].value?.map(siteId => siteId);
  const selectedParkingStatus = props.value[PARKERS_PROPS.PARKING].value?.map(parkingStatus => parkingStatus);
  const selectedSubscriptionStatus = props.value[PARKERS_PROPS.USER_ADDITIONAL_DATA].value?.map(subscriptionStatus => subscriptionStatus);
  const selectedUserTypeIds = props.value[PARKERS_PROPS.USER_TYPES].value?.map(userTypeId => userTypeId);
  //const selectedCampaignTypeIds = props.value[CAMPAIGN_PROPS.CAMPAIGN_TYPE].value?.map(userTypeId => userTypeId);
  const selectedApp = props.value[PARKERS_PROPS.APP].value;
  const selectedElectric = props.value[PARKERS_PROPS.ELECTRIC].value;
  const selectedValidationType = props.value[HISTORY_PROPS.VALIDATION_TYPE].value;
  const selectedCampaignType = props.value[CAMPAIGN_PROPS.CAMPAIGN_TYPE].value;
  const minDate = props?.minDate ? props?.minDate : null;
  const maxDate = props?.maxDate ? props?.maxDate : null;

  const [startTime, setStartTime] = React.useState(null);
  const [endTime, setEndTime] = React.useState(null);

  // Limits for one selection on filter options by given selections array
  const getOneSelection = (selectionsArr) => {
    // Removes the old selection that resides on the first element
    // of the received selections array
    if (Array.isArray(selectionsArr) && selectionsArr?.length > 1) {
      selectionsArr.shift();
    }

    return selectionsArr;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSites = (event, selectedSites) => {
    props.onChange({
      ...props.value,
      ...{ [PARKERS_PROPS.SITES]: { value: selectedSites } },
    });
  };

  const handleParkingStatus = (event, selectedStatuses) => {
    selectedStatuses = getOneSelection(selectedStatuses);

    props.onChange({
      ...props.value,
      ...{ [PARKERS_PROPS.PARKING]: { value: selectedStatuses } },
    });
  };

  const handleSubscriptionStatus = (event, selectedStatuses) => {
    selectedStatuses = getOneSelection(selectedStatuses);

    props.onChange({
      ...props.value,
      ...{ [PARKERS_PROPS.USER_ADDITIONAL_DATA]: { value: selectedStatuses } },
    });
  };

  const handleUserTypes = (event, selectedUserTypes) => {
    props.onChange({
      ...props.value,
      ...{ [PARKERS_PROPS.USER_TYPES]: { value: selectedUserTypes } },
    });
  };

  const handleApp = (selectedApp) => {
    props.onChange({
      ...props.value,
      ...{ [PARKERS_PROPS.APP]: { value: selectedApp } },
    });
  };

  const handleElectric = (selectedElectric) => {
    props.onChange({
      ...props.value,
      ...{ [PARKERS_PROPS.ELECTRIC]: { value: selectedElectric } },
    });
  };

  const handleDates = (selectedDates) => {
    // if theres value in both startTime and endTime, and there is rows with date
    if (selectedDates.every(sd => sd !== null) && props?.foundedDateKey !== null) {
      // props.onChange({
      //   ...props.value,
      //   ...{ [HISTORY_PROPS.DATE]: { value: selectedDates } },
      // });

      props.onChange({
        ...props.value,
        ...{ [props?.foundedDateKey]: { value: selectedDates } },
      });
    }
  };

  const handleCampaignTypes = (event, selectedCampaignType) => {
    selectedCampaignType = getOneSelection(selectedCampaignType);

    props.onChange({
      ...props.value,
      ...{ [CAMPAIGN_PROPS.CAMPAIGN_TYPE]: { value: selectedCampaignType } },
    });
  };

  const handleValidationTypes = (event, selectedValidationType) => {
    selectedValidationType = getOneSelection(selectedValidationType);

    props.onChange({
      ...props.value,
      ...{ [HISTORY_PROPS.VALIDATION_TYPE]: { value: selectedValidationType } },
    });
  };

  const handleChargeAccount = (event) => {
    props.onChange({
      ...props.value,
      ...{ [HISTORY_PROPS.CHARGE_ACCOUNT]: { value: [event[HISTORY_PROPS.CHARGE_ACCOUNT]] } }, // [event?.chargeAccount]
    });
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className={classes.quickFilter}>
      <Button
        sx={{ color: Colors.URTON_MAIN_COLOR }}
        aria-describedby={id}
        startIcon={<FilterListIcon />}
        variant="text"
        onClick={handleClick}
      >
        Filter
      </Button>
      <div>
        <Popover
          classes={{ paper: classes.paper }}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <div className={classes.filterContent}>
            <div className={classes.filterHeader}>
              <span className={classes.title}>{Strings.FILTER_TYPES.QUICK_FILTER}</span>
              <Button
                onClick={() => {
                  setStartTime(null);
                  setEndTime(null);

                  props.clearSearch();
                }}
                className={classes.clearButton}
              >
                {Strings.FILTER_TYPES.CLEAR_ALL}
              </Button>
            </div>
            
            {props?.tableId === TABLES.PARKERS || props?.tableId === TABLES.GUESTS ? (
              <Stack className={classes.filterTypes} direction="row" spacing={4}>
              {/* parking locations */}
              <div className={classes.group}>
                <span className={classes.typeTitle}>{Strings.FILTER_TYPES.PARKING_LOCATIONS}</span>
                <ToggleButtonGroup
                  value={props.value[PARKERS_PROPS.SITES].value}
                  onChange={handleSites}
                  aria-label={PARKERS_PROPS.SITES}
                  className={classes.type}
                  
                >
                  {currentSites?.map((site) => {
                    return (
                      <ToggleButton
                        className={classes.item}
                        value={site.id}
                        aria-label={site.name}
                        key={site.id}
                        classes={selectedSiteIds.includes(site.id) ? { selected: classes.selected } : { selected: '' }} 
                      >
                        <CustomIcon iconName={getSiteIconName(site.clientId)} />
                        <span>
                          {site.name}, {site.address}
                        </span>
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div>
              {/* User Type */}
              <div className={classes.group}>
                <span className={classes.typeTitle}>{Strings.FILTER_TYPES.USER_TYPES}</span>
                <ToggleButtonGroup
                  value={props.value[PARKERS_PROPS.USER_TYPES].value}
                  onChange={handleUserTypes}
                  aria-label={PARKERS_PROPS.USER_TYPES}
                  className={classes.type}
                >
                  {currentUserTypes?.map((userType) => {
                    return (
                      <ToggleButton
                        className={classes.item}
                        value={userType.id}
                        aria-label={userType.type}
                        key={userType.id}
                        classes={selectedUserTypeIds.includes(userType.id) ? { selected: classes.selected } : { selected: '' }}
                      >
                        <CustomIcon img={Icons.USER_TYPE} />
                        <span>{userType.type}</span>
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div>
              {/* Parking - will be shown only on scope type - project */}
              {selectedScope?.type === SCOPE_TYPE.PROJECT && (
                <div className={classes.group}>
                  <span className={classes.typeTitle}>{Strings.FILTER_TYPES.PARKING}</span>
                  <ToggleButtonGroup
                    value={props.value[PARKERS_PROPS.PARKING].value}
                    onChange={handleParkingStatus}
                    aria-label={PARKERS_PROPS.PARKING}
                    className={classes.type}
                  >
                    {Object.keys(PARKING_STATUSES)?.map((status) => {
                      return (
                        <ToggleButton
                          className={classes.item}
                          value={PARKING_STATUSES[status]}
                          aria-label={status}
                          key={status}
                          classes={selectedParkingStatus.includes(PARKING_STATUSES[status]) ? { selected: classes.selected } : { selected: '' }}
                        >
                          <span>{status}</span>
                        </ToggleButton>
                      );
                    })}
                  </ToggleButtonGroup>
                </div>                
              )}
              {/* Subscription Status */}
              <div className={classes.group}>
                <span className={classes.typeTitle}>{Strings.FILTER_TYPES.SUBSCRIPTION_STATUS}</span>
                <ToggleButtonGroup
                  value={props.value[PARKERS_PROPS.USER_ADDITIONAL_DATA].value}
                  onChange={handleSubscriptionStatus}
                  aria-label={PARKERS_PROPS.USER_ADDITIONAL_DATA}
                  className={classes.type}
                >
                  {Object.keys(SUBSCRIPTION_STATUSES)?.map((status) => {
                    return (
                      <ToggleButton
                        className={classes.item}
                        value={SUBSCRIPTION_STATUSES[status]}
                        aria-label={status}
                        key={status}
                        classes={selectedSubscriptionStatus.includes(SUBSCRIPTION_STATUSES[status]) ? { selected: classes.selected } : { selected: '' }}
                      >
                        <span>{capitalCaseToTitleCaseString(status)}</span>
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div>
              {/* other */}
              <div className={classes.group}>
                <span className={classes.typeTitle}>{Strings.FILTER_TYPES.OTHER}</span>
                {props.tableId === TABLES.PARKERS && (
                  <ToggleButton
                    className={classes.item}
                    value={props.value[PARKERS_PROPS.APP].value}
                    selected={props.value[PARKERS_PROPS.APP].value}
                    onChange={() => {
                      handleApp(!props.value[PARKERS_PROPS.APP].value);
                    }}
                    classes={selectedApp ? { selected: classes.selected } : { selected: '' }}
                  >
                    <CustomIcon img={Icons.APP} />
                    <span>App</span>
                  </ToggleButton>
                )}

                {props.tableId === TABLES.GUESTS && (
                  <ToggleButton
                    className={classes.item}
                    value={props.value[PARKERS_PROPS.ELECTRIC].value}
                    selected={props.value[PARKERS_PROPS.ELECTRIC].value}
                    onChange={() => {
                      handleElectric(
                        !props.value[PARKERS_PROPS.ELECTRIC].value
                      );
                    }}
                    classes={selectedElectric ? { selected: classes.selected } : { selected: '' }}
                  >
                    <CustomIcon img={Icons.Electric} />
                    <span>Electric</span>
                  </ToggleButton>
                )}
              </div>
            </Stack>
            ) : (props?.tableId === TABLES.HISTORY || props?.tableId === TABLES.BILLING_HISTORY) ? (
              
              <Stack className={classes.filterTypes} direction="row" spacing={1}>
                {/* Date */}
                <div className={classes.group}>
                  <span className={classes.typeTitle}>{Strings.FILTER_TYPES.DATE}</span>                
                    <Box className={classes.customDatePickerContainer}>
                      <div className={classes.customDatePickerMargin}>
                        <CustomDatePicker
                            width={'80%'}
                            label={Strings.INPUT_LABELS.START_DATE}
                            value={startTime}
                            minDate={startTime !== null && endTime > startTime ? startTime : minDate} 
                            maxDate={endTime !== null ? endTime : maxDate} 
                            onSelectedDate={(newStartTime) => {
                                setStartTime(newStartTime);
                                handleDates([newStartTime, endTime]);
                            }}
                        />
                      </div>
                      <div className={classes.customDatePickerMargin}>
                        <CustomDatePicker
                            width={'80%'}
                            label={Strings.INPUT_LABELS.END_DATE}
                            value={endTime}
                            minDate={startTime > minDate ? startTime : minDate} 
                            maxDate={startTime > maxDate ? startTime : maxDate} 
                            onSelectedDate={(newEndTime) => {
                                setEndTime(newEndTime);
                                handleDates([startTime, newEndTime]);
                            }}
                        />                     
                      </div>
                    </Box>
                </div>
                {/* Validation Types */}
                <div className={classes.group}>
                  <span className={classes.typeTitle}>{Strings.FILTER_TYPES.VALIDATION_TYPES}</span>
                  <ToggleButtonGroup
                    value={props.value[HISTORY_PROPS.VALIDATION_TYPE].value}
                    onChange={handleValidationTypes}
                    aria-label={HISTORY_PROPS.VALIDATION_TYPE}
                    className={classes.type}
                  >
                    {Object.values(VALIDATION_TYPE)?.map((type, index) => {
                    return (
                      <ToggleButton
                        className={classes.item}
                        value={type}
                        aria-label={type}
                        key={index}
                        classes={selectedValidationType.includes(type) ? { selected: classes.selected } : { selected: '' }}
                      >
                        <span>{type}</span>
                      </ToggleButton>
                    );
                  })}
                  </ToggleButtonGroup>
                </div>
                {props?.tableId === TABLES.BILLING_HISTORY &&
                  // Charge Account                
                  <div className={classes.group}>
                    <span className={classes.typeTitle}>{Strings.FILTER_TYPES.CHARGE_ACCOUNT}</span>
                    <SelectInput
                      id={HISTORY_PROPS.CHARGE_ACCOUNT}
                      onChange={handleChargeAccount}
                      value={props.value[HISTORY_PROPS.CHARGE_ACCOUNT].value ? props.value[HISTORY_PROPS.CHARGE_ACCOUNT].value : ''} 
                      list={chargeAccountList}
                      sx={{width: '225px'}}
                      paperClass={customInputClasses.paperPosition}
                    />               
                  </div>
                }
              </Stack>
            ) : (
              <Stack className={classes.filterTypes} direction="row" spacing={1}>
                {/* Date */}
                <div className={classes.group}>
                  <span className={classes.typeTitle}>{Strings.FILTER_TYPES.DATE}</span>                
                    <Box className={classes.customDatePickerContainer}>
                      <div className={classes.customDatePickerMargin}>
                        <CustomDatePicker
                            width={'80%'}
                            label={Strings.INPUT_LABELS.START_DATE}
                            value={startTime}
                            minDate={startTime !== null && endTime > startTime ? startTime : minDate} 
                            maxDate={endTime !== null ? endTime : maxDate} 
                            onSelectedDate={(newStartTime) => {
                                setStartTime(newStartTime);
                                handleDates([newStartTime, endTime]);
                            }}
                        />
                      </div>
                      <div className={classes.customDatePickerMargin}>
                        <CustomDatePicker
                            width={'80%'}
                            label={Strings.INPUT_LABELS.END_DATE}
                            value={endTime}
                            minDate={startTime > minDate ? startTime : minDate} 
                            maxDate={startTime > maxDate ? startTime : maxDate} 
                            onSelectedDate={(newEndTime) => {
                                setEndTime(newEndTime);
                                handleDates([startTime, newEndTime]);
                            }}
                        />                     
                      </div>
                    </Box>
                </div>
                {(props?.tableId === TABLES.CAMPAIGNS || props?.tableId === TABLES.MESSAGING_HISTORY) &&
                  // Campaign Types
                  <div className={classes.group}>
                    <span className={classes.typeTitle}>{Strings.FILTER_TYPES.CAMPAIGN_TYPES}</span>
                    <ToggleButtonGroup
                      value={props.value[CAMPAIGN_PROPS.CAMPAIGN_TYPE].value}
                      onChange={handleCampaignTypes}
                      aria-label={CAMPAIGN_PROPS.CAMPAIGN_TYPE}
                      className={classes.type}
                    >
                      {Object.values(CAMPAIGN_TYPE_LIST)?.map((type) => {
                      return (
                        <ToggleButton
                          className={classes.item}
                          value={type?.value}
                          aria-label={type?.label}
                          key={type?.id}
                          classes={selectedCampaignType.includes(type?.value) ? { selected: classes.selected } : { selected: '' }}
                        >
                          <CustomIcon img={type?.value === CAMPAIGN_TYPES.MAIL ? Icons.EMAIL : Icons.PHONE} />
                          <span>{type?.label}</span>
                        </ToggleButton>
                      );
                    })}
                    </ToggleButtonGroup>
                  </div>
                }
              </Stack>
              )
            }      
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default QuickFilterToolBar;
